import React from 'react'
import Box from '@mui/joy/Box'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Radio from '@mui/joy/Radio'
import RadioGroup, { type RadioGroupProps } from '@mui/joy/RadioGroup'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import { SortBy } from '../types'

export default function SortingSelector({
    value,
    handleChange,
}:{
    value: SortBy,
    handleChange: RadioGroupProps['onChange'],
}) {

    const { t } = useTranslation()

    return (
        <Box>
            <FormControl>
                <FormLabel><Typography level='title-md'>{t('filters.sortBy')}</Typography></FormLabel>
                <RadioGroup
                    value={value}
                    name="sort"
                    orientation="horizontal"
                    onChange={handleChange}
                >
                    <Radio value={SortBy.distance} label={t('filters.distance')} />
                    <Radio value={SortBy.price} label={t('filters.price')} />
                </RadioGroup>
            </FormControl>
        </Box>
    )
}